import { render, staticRenderFns } from "./charm-word.vue?vue&type=template&id=1226a93c&scoped=true&"
import script from "./charm-word.vue?vue&type=script&lang=js&"
export * from "./charm-word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226a93c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1226a93c')) {
      api.createRecord('1226a93c', component.options)
    } else {
      api.reload('1226a93c', component.options)
    }
    module.hot.accept("./charm-word.vue?vue&type=template&id=1226a93c&scoped=true&", function () {
      api.rerender('1226a93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/charm-word.vue"
export default component.exports